import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=0b6b211b&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=ts&"
export * from "./MyAccount.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=0b6b211b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b211b",
  null
  
)

export default component.exports